import * as R from "ramda"
import { getStoreKeyByName } from "../Steps";

const nameStoreFormValue = getStoreKeyByName('usage')

const usageFormData = {
  useCollectInfo: [
    { label: 'Providing and maintaining the Service', value: 'Providing and maintaining the Service', disabled: false, custom: false },
    { label: 'Managing user account', value: 'Managing user account', disabled: false, custom: false },
    { label: 'For the performance of a contract', value: 'For the performance of a contract', disabled: false, custom: false },
    { label: 'To contact user', value: 'To contact user', disabled: false, custom: false },
    { label: 'To keep user updated', value: 'To keep user updated', disabled: false, custom: false },
    { label: 'Marketing and promotional initiatives', value: 'Marketing and promotional initiatives', disabled: false, custom: false },
    { label: 'Targeted advertising', value: 'Targeted advertising', disabled: false, custom: false },
    { label: 'User feedback collection', value: 'User feedback collection', disabled: false, custom: false },
    { label: 'Managing customer orders', value: 'Managing customer orders', disabled: false, custom: false },
    { label: 'Website administration', value: 'Website administration', disabled: false, custom: false },
    { label: 'Dispute resolution', value: 'Dispute resolution', disabled: false, custom: false },
    { label: 'User to user comments', value: 'User to user comments', disabled: false, custom: false },
    { label: 'Other purposes', value: 'Other purposes', disabled: false, custom: false },
  ],

  shareCollectInfo: [
    { label: 'With user consent', value: 'With user consent', disabled: false, custom: false },
    { label: 'For transfers of business', value: 'For transfers of business', disabled: false, custom: false },
    { label: 'Sharing with affiliates', value: 'Sharing with affiliates', disabled: false, custom: false },
    { label: 'Sharing with other users', value: 'Sharing with other users', disabled: false, custom: false },
  ],

  thirdPartyService: [
    { label: 'Analytics information (like Google Analytics)', value: 'Analytics information (like Google Analytics)', disabled: false, custom: false },
    { label: 'Service improving (like HelpScout)', value: 'Service improving (like HelpScout)', disabled: false, custom: false },
    { label: 'Payment processing services (like PayPal)', value: 'Payment processing services (like PayPal)', disabled: false, custom: false },
    { label: 'Marketing initiatives (like MailChimp)', value: 'Marketing initiatives (like MailChimp)', disabled: false, custom: false },
    { label: 'Improving targeted advertising campaigns (like Google Ads)', value: 'Improving targeted advertising campaigns (like Google Ads)', disabled: false, custom: false },
  ]
}


const defaultValue = {
  useCollectInfo: ['Providing and maintaining the Service', 'Other purposes'],
  shareCollectInfo: ['With user consent'],
  isUseThirdPartyService: false,
  thirdPartyService: []
}

export const usageFormState = set =>  ({
  usageFormData: usageFormData,
  resetUsageFormData: () => set({ usageFormData: usageFormData  }),
  addUsageFormDataByKey: (key, item) => (set(state => {
    const newValue = [...state.usageFormData[key], item ];
    return { usageFormData:  { ...state.usageFormData, [key]: newValue } }
  })),
  removeUsageFormDataByKey: (key,item) => set(state => {
    const compareFunc = option => option.value !== item.value
    const newValue = R.filter(compareFunc, state.usageFormData[key])

    return { usageFormData:  { ...state.usageFormData, [key]: newValue } }
  }),

  [nameStoreFormValue]:  defaultValue,
  resetUsageFormValue: () => set({ [nameStoreFormValue]: defaultValue  }),
  setUsageFormValue: value => set({ [nameStoreFormValue]: value}),
  changeUsageFormValue: (name, value) =>
    set(state => ({ [nameStoreFormValue]: {...state[nameStoreFormValue], [name]: value } })),
})